<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<h1>供給停止予定検索画面</h1>

<form [formGroup]="sgke312arequestForm" (ngSubmit)="onClickSearch()">
    <div *ngIf="cmpnyAreaList?.length > 0 && codeConversionMstMap?.size > 0">
        <!-- 検索条件コンポーネント -->
        <app-sgke310d-condition [codeConversionMstMap]="codeConversionMstMap" [cmpnyAreaList]="cmpnyAreaList"
            [cmpnyAreaInit]="cmpnyAreaInit" (onClickSearchEvent)="onClickSearch()" (onClickClearEvent)="onClickClear()">
        </app-sgke310d-condition>
    </div>
</form>

<div *ngIf="searchresultList.length > 0">
    <!-- 検索結果コンポーネント -->
    <app-sgke310d-result [searchresultList]="searchresultList" [searchresultHyojiInfo]="searchresultHyojiInfo"
        [targetDate]="businessDate" (onClickRegistEvent)="onClickRegist($event)"(onDblClickEvent)="navigateBillPortal($event)">
    </app-sgke310d-result>
</div>